import { styled } from '@mui/material/styles'

const getStyles = (theme) => (
  {
    root: {
      backgroundColor: theme.mode === 'dark' ? '#000' : '#e8e8e8d9'
    },
    list: {

      [theme.breakpoints?.down('sm')]: {
        padding: '0 10px 30px'
      },
      [theme.breakpoints?.up('sm')]: {
        padding: '100px 0'
      }
    },
    listTitle: {
      color: theme.mode === 'dark' ? '#bebaba' : '#8b8b8b'
    },
    listContainer: {
      minHeight: '100vh',
      background: theme.mode === 'dark'
        ? 'linear-gradient(180deg, rgb(110 110 110) 1%, rgb(255 255 255) 76%, rgb(255 255 255) 95%)'
        : 'linear-gradient(180deg, rgba(255,255,255,1) 1%, rgba(194,194,194,1) 76%, rgba(194,194,194,1) 95%)'

    },
    switchTheme: {
      position: 'absolute !important',
      right: 30,
      top: 30,
      zIndex: 3
    }
  }
)
const PREFIX = 'HomeStyle'
const classes = {}
const classNames = Object.keys(getStyles({}))

classNames.forEach(key => {
  classes[key] = `${PREFIX}-${key}`
})

const HomeStyle = styled('div')(({ theme }) => {
  const styles = getStyles(theme)
  const myClass = {}
  classNames.forEach(key => {
    const className = key === 'root' ? `&.${classes.root}` : `& .${classes[key]}`
    myClass[className] = {
      ...styles[key]
    }
  })
  return (myClass)
})

export {
  classes,
  HomeStyle
}
